import gus from '../assets/img/Gustavo.jpeg'
import dr from '../assets/img/Dr_Sara.png'
import A from '../assets/img/alejandro.jpeg'
import J from '../assets/img/J.jpg'

export const collectionCreditos = [
    {
        id: 1,
        autor: 'Gustavo Martinez Villalobos',
        description: 'Profesor Asociado e investigador del grupo GESE - Unibagué.',
        link: 'gustavo.martinez@unibague.edu.co',
        img: gus
    },
    {
        id: 2,
        autor: 'Sara Torres Hernández',
        description: 'Jefa del departamento de investigación del Centro Chihuahuense de Estudios de Posgrado',
        link: 'sara.torres.h@cchep.edu.mx',
        img: dr
    }
    ,
    {
        id: 3,
        autor: 'Alejandro Luna Miranda',
        description: 'Asistente de investigación, Desarrollador Aplicación Web',
        link: '2220131011@estudi...',
        img: A
    }
    ,
    {
        id: 4,
        autor: 'Jorge David Sigindioy Muchavisoy',
        description: 'Asistente de investigación, Desarrollador App Movil',
        link: '2220151021@estudi...',
        img: J
    }
]
